import React from "react";

import { useDeviceTesterStateContext } from "../device-tester-context-provider/DeviceTesterContextProvider";

import { PrivacyFooter } from "./PrivacyFooter";

export const ConnectedPrivacyFooter: React.FC = () => {
  const { deviceTesterState } = useDeviceTesterStateContext();

  return <PrivacyFooter disabled={!deviceTesterState.isInfoFetched} />;
};
